export default {
  common: {
    account: 'Tài khoản',
    agents: 'Agent',
    all: 'Tất cả',
    available: 'Khả dụng',
    cancel: 'Hủy',
    cloud: 'Đám mây',
    copy: 'Sao chép',
    current: 'hiện tại',
    delete: 'Xóa',
    error: 'Lỗi',
    export: 'Xuất',
    help: 'Trợ giúp',
    home: 'Trang chủ',
    language: 'Ngôn ngữ',
    links: 'Liên kết',
    loading: 'đang tải',
    local: 'Cục bộ',
    login: 'Đăng nhập',
    logout: 'Đăng xuất',
    metadata: 'Siêu dữ liệu',
    more: 'Thêm',
    name: 'Tên',
    never: 'Chưa bao giờ',
    none: 'không có',
    notes: 'Ghi chú',
    ok: 'Ok',
    open: 'Mở',
    password: 'mật khẩu',
    project: 'dự án',
    projects: 'Dự án',
    publicLink: 'Liên kết công khai',
    register: 'Đăng ký',
    remove: 'Gỡ',
    save: 'Lưu',
    search: 'Tìm kiếm',
    settings: 'Cài đặt',
    subscribe: 'Đăng ký gói',
    track: 'track',
    tracks: 'Track',
    unknown: 'Không rõ',
    unknownArtist: 'Nghệ sĩ không rõ',
    upload: 'Tải lên',
    username: 'tên người dùng'
  },
  time: {
    day: 'ngày',
    days: 'ngày',
    daysAgo: (ctx) => `${ctx.named('count')} ngày trước`,
    hoursAgo: (ctx) => `${ctx.named('count')} giờ trước`,
    minutesAgo: (ctx) => `${ctx.named('count')} phút trước`,
    rightNow: 'ngay bây giờ',
    duration: (ctx) => {
      const minutes = Number(ctx.named('minutes'))
      const seconds = Number(ctx.named('seconds'))
      if (minutes > 0) return `${minutes} phút ${seconds} giây`
      return `${seconds} giây`
    }
  },
  topBar: {
    accountFallback: 'Tài khoản',
    storage: 'Lưu trữ',
    language: 'Ngôn ngữ'
  },
  commandPalette: {
    placeholder: 'Tìm track và dự án...',
    projects: 'Dự án',
    tracks: 'Track',
    pages: 'Trang',
    noResults: 'Không tìm thấy kết quả',
    quickLinks: 'Liên kết nhanh',
    page: {
      home: 'Trang chủ',
      account: 'Tài khoản',
      agents: 'Agent',
      links: 'Liên kết',
      settings: 'Cài đặt',
      help: 'Trợ giúp'
    }
  },
  explorer: {
    searchTitle: 'Tìm kiếm',
    trackCount: (ctx) => `${ctx.named('count')} track`
  },
  emptyState: {
    hello: 'xin chào',
    addTrack: 'Thêm track',
    addTrackSubtitle: 'để bắt đầu',
    dragDrop: 'Kéo và thả',
    dragDropSubtitle: 'file của bạn để tải nhanh',
    switchStorage: 'Chuyển đổi',
    switchStorageSubtitle: 'giữa đám mây và cục bộ trong menu trên',
    installAgent: 'Cài agent',
    installAgentSubtitle: 'để tự động tải file của bạn',
    playTrack: 'Phát track',
    playTrackSubtitle: 'mở player dưới cùng để dùng hiệu ứng',
    community: 'có câu hỏi? tham gia cộng đồng của chúng tôi trên {discord} và {telegram}.'
  },
  create: {
    createProject: 'Tạo dự án',
    uploadTrack: 'Tải track lên',
    newProject: 'Dự án mới',
    artist: 'Nghệ sĩ',
    name: 'Tên',
    create: 'Tạo',
    loading: 'Đang tải...',
    uploadCover: 'Tải bìa lên'
  },
  upload: {
    ariaLabel: 'Tải track lên',
    uploadTrack: 'Tải track lên',
    analyzing: 'Đang phân tích...',
    fileAdded: 'Đã thêm file "{name}"',
    fileReadError: 'Lỗi đọc file.',
    errorWithMessage: 'Lỗi: {message}'
  },
  dragDrop: {
    dropToUpload: 'Thả để tải lên',
    deleteDrop: 'Thả vào đây để xóa track vĩnh viễn'
  },
  project: {
    upload: 'Tải lên',
    noTracks: 'Không có track',
    createdBy: 'tạo bởi',
    trackSummary: (ctx) => `${ctx.named('count')} track, ${ctx.named('duration')}`,
    play: 'Phát',
    pause: 'Tạm dừng'
  },
  trackItem: {
    more: 'Thêm',
    copyPublicLink: 'Sao chép liên kết công khai',
    savedLocally: 'Đã lưu cục bộ',
    saveLocal: 'Lưu vào bộ nhớ cục bộ',
    saving: 'Đang lưu...',
    saveCloud: 'Lưu lên đám mây',
    deleteTrack: 'Xóa track',
    moveUp: 'Di chuyển lên',
    moveDown: 'Di chuyển xuống',
    removeFromProject: 'Gỡ khỏi {project}',
    moveToProject: 'Di chuyển tới dự án',
    currentProject: '(hiện tại)',
    confirmDelete: 'Bạn có chắc muốn xóa track này không?',
    linkCopiedTitle: 'Đã sao chép liên kết',
    linkCopiedDescription: 'Liên kết công khai đã được sao chép vào clipboard'
  },
  trackView: {
    created: 'đã tạo {time}',
    tabs: {
      notes: 'Ghi chú',
      metadata: 'Siêu dữ liệu'
    },
    notFound: 'không tìm thấy track hoặc bạn không có quyền truy cập',
    untitled: 'Chưa đặt tên'
  },
  notes: {
    placeholder: 'Thêm ghi chú về track này...',
    saving: 'Đang lưu...',
    saveError: 'Không thể lưu ghi chú. Vui lòng thử lại.'
  },
  metadata: {
    trackOrder: 'Thứ tự track',
    artist: 'Nghệ sĩ',
    name: 'Tên',
    key: 'Key',
    mode: 'Mode',
    deleteTrack: 'Xóa track',
    saveError: 'Không thể lưu siêu dữ liệu. Vui lòng thử lại.'
  },
  lufs: {
    momentary: 'LUFS tức thời',
    shortTerm: 'LUFS ngắn hạn',
    integrated: 'LUFS tích hợp'
  },
  effects: {
    pitchshift: 'Đổi cao độ',
    speed: 'Tốc độ',
    balance: 'Cân bằng',
    volume: 'Âm lượng',
    reverberation: 'Vang',
    distortion: 'Méo tiếng',
    bitcrush: 'Bitcrush',
    saveCurrentEffectsAs: 'Lưu hiệu ứng hiện tại thành',
    presetName: 'Tên',
    add: 'Thêm',
    availablePresets: 'Preset có sẵn',
    tune: 'Tune',
    eq: 'EQ',
    fx: 'FX',
    presets: 'Preset',
    center: 'Giữa',
    left: 'Trái',
    right: 'Phải'
  },
  exportPanel: {
    applyEffects: 'Áp dụng hiệu ứng hiện tại',
    applyEffectsSubtitle: 'Xuất track với hiệu ứng hiện tại',
    exportWav: 'Xuất dạng WAV',
    exportMp3: 'Xuất dạng MP3',
    exporting: 'Đang xuất...',
    exportAsNewTrack: 'Xuất thành track mới',
    creatingTrack: 'Đang tạo track...',
    downloadOriginal: 'Tải bản gốc',
    originalUnavailable: 'File gốc không khả dụng.',
    downloadOriginalFailed: 'Không thể tải file gốc.',
    exportAudioFailed: 'Không thể xuất audio của track.',
    waveformFailed: 'Không thể tạo waveform.',
    createTrackFailed: 'Không thể tạo track đã xuất.',
    createTrackAlert: 'Không thể tạo track đã xuất: {message}',
    exportedSuffix: ' (bản xuất)',
    copySuffix: ' (bản sao)'
  },
  publicLink: {
    copy: 'Sao chép',
    open: 'Mở',
    linkCopiedTitle: 'Đã sao chép liên kết',
    linkCopiedDescription: 'Liên kết công khai đã được sao chép vào clipboard'
  },
  settings: {
    tabs: {
      settings: 'Cài đặt',
      account: 'Tài khoản',
      links: 'Liên kết',
      agents: 'Agent'
    },
    display: 'Hiển thị',
    language: 'Ngôn ngữ',
    showBpm: 'Hiển thị BPM trong trang track',
    showBpmSubtitle: 'Hiển thị beats per minute cho mỗi track trong danh sách',
    showLufs: 'Hiển thị LUFS trong trang track',
    showLufsSubtitle: 'Hiển thị đơn vị độ lớn âm thanh cho mỗi track trong danh sách',
    showKey: 'Hiển thị key trong trang track',
    showKeySubtitle: 'Hiển thị key và mode cho mỗi track trong danh sách',
    playback: 'Phát',
    liveLoudness: 'Đo loudness trực tiếp',
    liveLoudnessSubtitle: 'Hiển thị meter loudness trực tiếp trên màn hình player',
    persistEffects: 'Giữ hiệu ứng đã áp dụng cho mọi track',
    persistEffectsSubtitle: 'Giữ hiệu ứng khi chuyển sang track khác',
    keyboardShortcuts: 'Phím tắt',
    search: 'Tìm kiếm',
    pressShortcut: 'Nhấn tổ hợp phím mong muốn',
    storage: 'Lưu trữ',
    resetPresetsInfo: 'Đặt lại tất cả preset được lưu trong trình duyệt này',
    resetPresets: 'Đặt lại preset',
    resetAllWarning: 'Cảnh báo! Nút bên dưới sẽ xóa toàn bộ dữ liệu trong bộ nhớ cục bộ.',
    resetAllData: 'Đặt lại bộ nhớ cục bộ và xóa tất cả track, dự án',
    loadingAccount: 'Đang tải tài khoản...',
    loadingLinks: 'Đang tải liên kết...',
    loadingAgents: 'Đang tải agent...',
    authPrompt: 'Đăng nhập hoặc đăng ký để dùng phần này.',
    loginRegister: 'Đăng nhập hoặc đăng ký',
    pageTitle: {
      settings: 'cài đặt',
      account: 'cài đặt tài khoản',
      links: 'liên kết công khai',
      agents: 'agent'
    },
    presetsCleared: 'Đã xóa bộ nhớ preset',
    localDataDeleted: 'Đã xóa toàn bộ dữ liệu cục bộ',
    linkCopied: 'Đã sao chép liên kết',
    linkCopyFailed: 'Không thể sao chép liên kết'
  },
  account: {
    hello: 'Xin chào {name}.',
    subscriptionStatus: 'Gói đăng ký của bạn hiện là {status}',
    noSubscription: 'Bạn không có gói đăng ký đang hoạt động.',
    manageSubscription: 'Quản lý gói đăng ký và phương thức thanh toán',
    subscribeCloud: 'Đăng ký để dùng đám mây',
    changeUsername: 'Đổi tên người dùng',
    changePassword: 'Đổi mật khẩu',
    saveUsername: 'Lưu tên người dùng',
    savePassword: 'Lưu mật khẩu',
    newPassword: 'mật khẩu mới',
    confirmPassword: 'xác nhận mật khẩu',
    usernamePlaceholder: 'tên người dùng của bạn',
    storageUsage: 'Dung lượng đã dùng',
    baseStorage: 'Dung lượng cơ bản',
    subscriptionStorage: 'Dung lượng gói đăng ký',
    used: 'Đã dùng',
    available: 'Khả dụng',
    deletedFilesNotice: 'Nếu bạn vừa xóa file, chúng vẫn có thể được tính trong các chỉ số này. Dữ liệu sẽ thay đổi trong vài giờ.',
    accountId: 'id tài khoản',
    currentPeriodEnds: (ctx) => `kỳ thanh toán hiện tại kết thúc sau ${ctx.named('count')} ${ctx.named('label')}`,
    accessEnds: (ctx) => `quyền truy cập gói đăng ký kết thúc sau ${ctx.named('count')} ${ctx.named('label')}`,
    lastPaymentEnded: (ctx) => `kỳ thanh toán trước kết thúc vào ${ctx.named('date')}`,
    previousBillingDate: 'ngày thanh toán trước',
    billingPortalError: 'Lỗi cổng thanh toán',
    billingPortalFailed: 'Không thể mở cổng thanh toán.',
    loginRequiredUpdate: 'Bạn cần đăng nhập để cập nhật hồ sơ.',
    usernameEmpty: 'Tên người dùng không được để trống.',
    usernameUnchanged: 'Tên người dùng không thay đổi.',
    usernameUpdated: 'Đã cập nhật tên người dùng',
    usernameUpdateFailed: 'Không thể cập nhật tên người dùng. Vui lòng thử lại.',
    passwordEmpty: 'Mật khẩu không được để trống.',
    passwordsMismatch: 'Mật khẩu không khớp.',
    passwordUpdated: 'Đã cập nhật mật khẩu',
    passwordUpdateFailed: 'Không thể cập nhật mật khẩu. Vui lòng thử lại.'
  },
  links: {
    title: 'Liên kết công khai',
    description: 'Tất cả liên kết công khai của bạn được liệt kê tại đây. Bất kỳ ai có quyền truy cập đều có thể nghe dự án hoặc track.',
    cloudOnly: 'Liên kết công khai chỉ có trong chế độ Đám mây. Chuyển sang lưu trữ Đám mây để tạo và quản lý liên kết công khai.',
    noLinks: 'Không có liên kết công khai',
    createFirst: 'Tạo liên kết công khai đầu tiên để bắt đầu chia sẻ.',
    confirmDelete: 'Bạn có chắc muốn xóa liên kết này không?',
    notFoundTitle: 'Không tìm thấy liên kết hoặc liên kết đã hết hạn',
    notFoundDescription: 'Liên kết bạn đang truy cập không hợp lệ hoặc đã hết hạn.',
    unknownUser: 'không rõ'
  },
  agents: {
    authorizeTitle: 'Ủy quyền agent',
    authorizeDescription: 'Cho phép agent này kết nối với tài khoản của bạn.',
    loginToAuthorize: 'Vui lòng đăng nhập để ủy quyền agent này.',
    wantsConnect: 'Agent này muốn kết nối với tài khoản của bạn để tự động tải file audio lên.',
    permissionUpload: 'Tải track lên',
    permissionMetadata: 'Tạo siêu dữ liệu track',
    authorize: 'Ủy quyền',
    cancel: 'Hủy',
    authorizedTitle: 'Agent đã được ủy quyền',
    authorizedDescription: 'Bây giờ bạn có thể đóng cửa sổ này và quay lại ứng dụng agent.',
    desktopTitle: 'Desktop Agent',
    installDescription: 'Cài demoparty agent trên PC hoặc Mac để tự động tải các bản render mới lên.',
    warningLabel: 'CẢNH BÁO: ',
    alphaWarning: 'agent đang ở trạng thái alpha và có thể không ổn định.',
    downloadMacApple: 'Tải cho Mac Apple Silicon',
    downloadMacIntel: 'Tải cho Mac Intel',
    downloadWindows: 'Tải cho Windows x64',
    signingNotice: 'Các bản build này chưa được ký số vì dự án vẫn đang phát triển. Cảnh báo bảo mật khi mở là điều có thể xảy ra. Bản build đã ký sẽ được cung cấp sau.',
    activeTitle: 'Agent đang hoạt động',
    connectedDescription: 'Agent đã kết nối với tài khoản của bạn.',
    loginToManage: 'Đăng nhập để quản lý agent của bạn.',
    noAgents: 'Chưa có agent nào được kết nối.',
    lastUsed: 'Dùng lần cuối',
    revoke: 'Thu hồi',
    remove: 'Gỡ',
    confirmRemove: 'Bạn có chắc muốn gỡ agent này không?',
    authorizeFailed: 'Không thể ủy quyền agent. Vui lòng thử lại.'
  },
  login: {
    intro: 'Bạn cần đăng nhập nếu muốn dùng tính năng đám mây và quyền lợi gói đăng ký. Nếu không, bạn có thể dùng dịch vụ cục bộ miễn phí.',
    subscriptionBenefits: 'quyền lợi gói đăng ký',
    login: 'Đăng nhập',
    register: 'Đăng ký',
    forgot: 'Tôi quên mật khẩu',
    email: 'e-mail',
    password: 'mật khẩu',
    repeatPassword: 'nhập lại mật khẩu',
    or: 'hoặc',
    google: 'Đăng nhập bằng Google',
    apple: 'Đăng nhập bằng Apple',
    resetPassword: 'Đặt lại mật khẩu',
    resetDescription: 'Chúng tôi sẽ gửi liên kết đăng nhập để bạn đặt mật khẩu mới.',
    sendResetLink: 'Gửi liên kết đặt lại',
    invalidToken: 'Token không hợp lệ hoặc đã hết hạn',
    enterEmail: 'Vui lòng nhập e-mail',
    resetSent: 'Nếu tài khoản tồn tại, chúng tôi đã gửi liên kết đăng nhập tới e-mail của bạn.',
    resetFailed: 'Không thể gửi liên kết đặt lại. Vui lòng thử lại.'
  },
  googleCallback: {
    wait: 'Vui lòng chờ, chúng tôi đang đăng nhập...'
  },
  subscribe: {
    cloudRequiredTitle: 'Cần lưu trữ đám mây',
    cloudRequiredMessage: 'Tính năng này chỉ khả dụng với lưu trữ đám mây và gói đăng ký đang hoạt động.',
    title: 'Bắt đầu cục bộ. Nâng cấp để tự động tải lên.',
    description: 'Đám mây cho bạn một thư viện đồng bộ trên nhiều thiết bị.',
    localFree: 'Bạn có thể dùng app miễn phí ở chế độ cục bộ.',
    cloudIncludes: 'Đám mây bao gồm',
    featureLibrary: 'Một thư viện đồng bộ giữa web và iPhone',
    featureAgent: 'Desktop agent tự động tải các bản render mới lên',
    featureStorage: '100 GB lưu trữ đám mây cho track',
    featureLinks: 'Liên kết công khai bền vững cho track và dự án',
    featureTools: 'Bao gồm toàn bộ công cụ phân tích, hiệu ứng và xuất cục bộ',
    monthly: 'Hàng tháng',
    monthlyDescription: 'Đồng bộ đám mây, hủy bất cứ lúc nào',
    yearly: 'Hàng năm',
    yearlyDescription: 'Giá trị tốt nhất cho đồng bộ đám mây',
    saveTen: 'Tiết kiệm 10%',
    perMonth: '/tháng',
    billedMonthly: 'Thanh toán hàng tháng',
    billedYearly: 'Thanh toán $53.89 mỗi năm',
    openingCheckout: 'Đang mở checkout...',
    subscribePlan: 'Đăng ký {plan}',
    registerSubscribe: 'Đăng ký tài khoản và gói',
    securePayment: 'Thanh toán an toàn qua Polar. Hủy bất cứ lúc nào từ cài đặt tài khoản.',
    customPlan: 'Cần gói riêng hoặc có câu hỏi? Liên hệ chúng tôi tại',
    privacy: 'Chính sách quyền riêng tư',
    terms: 'Điều khoản dịch vụ',
    refund: 'Chính sách hoàn tiền',
    checkoutFailed: 'Không thể tạo checkout. Vui lòng thử lại.'
  },
  thanks: {
    title: 'Cảm ơn bạn đã đăng ký!',
    description: 'Bây giờ bạn có thể dùng lưu trữ đám mây. Để quản lý gói đăng ký, hãy xem trang tài khoản.',
    startWorking: 'Bắt đầu làm việc',
    communities: 'Tham gia cộng đồng',
    support: 'Nếu có vấn đề, hãy liên hệ chúng tôi tại {email} hoặc qua các liên kết cộng đồng ở trên.'
  },
  help: {
    title: 'Trợ giúp',
    intro: 'demoparty là workspace cho nhạc chưa hoàn thiện và các dự án đang làm. Nó cho phép bạn lưu demo, áp dụng hiệu ứng, chỉnh tag và theo dõi siêu dữ liệu kỹ thuật. Dùng cục bộ hoàn toàn miễn phí.',
    uploadTitle: 'Tải lên',
    uploadText: 'Bạn có thể thêm track bằng cách nhấn nút Add trên trang chính. Trong khi tải lên, hệ thống tự động phát hiện key, BPM và LUFS. Khi tải xong, bạn sẽ nhận thông báo xác nhận.',
    storageTitle: 'Lưu trữ',
    storageText: 'demoparty cung cấp hai lựa chọn lưu trữ: cục bộ và đám mây.',
    localStorageText: 'Lưu trữ cục bộ giữ toàn bộ dữ liệu chỉ trên thiết bị của bạn. Track và dự án chỉ khả dụng trong trình duyệt nơi chúng được tải lên. IndexedDB được dùng để lưu trữ. Không cần đăng ký và không gửi dữ liệu đi đâu.',
    cloudStorageText: 'Lưu trữ đám mây giữ dữ liệu trên máy chủ demoparty. Bạn có thể truy cập track từ bất cứ đâu, bất cứ lúc nào. Cần đăng ký và gói đăng ký đang hoạt động.',
    agentsTitle: 'Agent',
    agentsText: 'Khi dùng lưu trữ đám mây, bạn có thể cài desktop agent. Agent tự động tải các track mới render lên đám mây.',
    publicLinksTitle: 'Liên kết công khai',
    publicLinksText: 'Người dùng đám mây có thể tạo liên kết công khai tới track và dự án. Trên trang dự án, nhấn nút liên kết. Với track, dùng cùng biểu tượng trong menu dropdown của track. Tất cả liên kết đã tạo có thể quản lý trong Cài đặt.',
    exportTitle: 'Xuất',
    exportText: 'Track có thể được xuất với toàn bộ hiệu ứng đã áp dụng. Mở trang track và chọn Xuất. Bạn có thể tải file gốc hoặc xuất dạng MP3/WAV.',
    supportTitle: 'Hỗ trợ',
    supportText: "Với vấn đề liên quan đến gói đám mây demoparty, liên hệ chúng tôi tại support{'@'}demoparty.app.",
    attributionsTitle: 'Ghi nhận',
    attributionsText: 'Các thư viện sau đã giúp dự án này trở thành hiện thực. Công lao thuộc về các nhà phát triển tương ứng.'
  },
  cover: {
    upload: 'Tải bìa lên',
    change: 'Đổi bìa',
    delete: 'Xóa bìa',
    loading: 'Đang tải...',
    selectImage: 'Vui lòng chọn file hình ảnh',
    uploadError: 'Lỗi tải bìa lên'
  }
}
